import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, Box, Typography } from "@mui/material";
import ArgonButton from "components/ArgonButton";
import ArgonTypography from "components/ArgonTypography";
import { deleteCategory } from "services/categoriesService";
const DeleteCategoryModal = ({ open, onClose, category, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setError("");
  }, [open]);

  const handleDelete = async () => {
    if (!category) {
      setError("Category not found.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await deleteCategory(category.value);
      setLoading(false);
      onSuccess();
      onClose();
    } catch (err) {
      setLoading(false);
      setError(
        "An error occurred while deleting the category. Please try again."
      );
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableBackdropClick
      PaperProps={{
        style: {
          borderRadius: "16px",
          padding: "20px 32px",
          textAlign: "center",
          backgroundColor: "#ffffff",
        },
      }}
    >
      <DialogContent>
        <Typography
          variant="h4"
          mb={3}
          color="#1A1D1F"
          fontSize={20}
          fontWright={600}
        >
          Delete Category
        </Typography>

        <Typography
          color="#373D3F"
          fontWeight={400}
          fontSize={14}
          mb={3}
          textAlign="center"
        >
          Are you sure you want to delete the '{category?.name}' category?
        </Typography>

        {error && (
          <ArgonTypography variant="body2" color="error" mb={2}>
            {error}
          </ArgonTypography>
        )}

        <Box display="flex" justifyContent="center" gap={2}>
          <ArgonButton
            variant="outlined"
            color="secondary"
            onClick={onClose}
            disabled={loading}
            sx={{ minWidth: 100, backgroundColor: "#ffff", color: "#2d3f50" }}
          >
            Cancel
          </ArgonButton>
          <ArgonButton
            variant="contained"
            color="#2d3f50"
            onClick={handleDelete}
            disabled={loading}
            sx={{
              minWidth: 100,
              backgroundColor: "#e53e3e",
              color: "#ffff",
              "&:hover": { backgroundColor: "#e53e3e" },
            }}
          >
            {loading ? "Deleting..." : "Delete"}
          </ArgonButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteCategoryModal;
